import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import HelpSpinners from "components/spinners";
import { Grid, _ } from "gridjs-react";

 import { useNavigate } from "react-router-dom";
import ModalDetalles from "./modal/detalles";

const Perfil = () => {
  const [loading, setLoading] = useState(true);
  const History = useNavigate();
  const [tabla, setTabla] = useState([]);

  const tablaF = async () => {
    const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/perfil.php`);
    const data = await res.json();
    setTabla(data);

    setLoading(false);
  };
  const Deletelink = async (data) => {
    const alert = await Swal.fire({
      title: "Desea eliminar esto ?",
      text: data,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar",
    });
    if (alert.isConfirmed) {
      const data1 = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/perfil.php`,
        {
          method: "DELETE",
          body: data,
        }
      );
      const res = await data1.json();

      if (res.status === "ok") {
        Swal.fire({
          title: "",
          icon: "success",
          timer: 2000,
          toast: true,
          position: "top-end",
          width: "10rem",
          showConfirmButton: false,
        });
        tablaF();
      } else {
        Swal.fire("No se pudo eliminar");
      }
    } else {
      Swal.fire("-");
    }
  };
 

  // const History = useNavigate();
  const [show, setShow] = useState({show_:false,id:0});
  const handleClose = () => setShow({...show,show_:false});

  useEffect(() => {
    tablaF();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="" style={{ height: "100vh", marginTop: "5%" }}>
      {loading ? (
        <div className="carga">
          <HelpSpinners loading={loading} size={300} />
        </div>
      ) : (
        <>
          <ModalDetalles
            show={show}
            tabla={tablaF}
            setShow={setShow}
            handleClose={handleClose}
          />

          <Grid
            data={tabla}
            resizable={true}
            columns={[
              {
                id: "id_persona",
                name: "#",
                width: "5%",
              },
              {
                id: "cedula",
                name: "Cedula",
                width: "10%",
              },
              {
                id: "nombre",
                name: "Nombre",
                width: "15%",
              },

              {
                id: "apellido",
                name: "Apellido",
                width: "15%",
              },
              {
                id: "Telefono",
                name: "Telefono",
                width: "10%",
              },

              {
                id: "perfilProfesional",
                name: "Profesion",
                width: "15%",
              },
              {
                id: "nombreLider",
                name: "Responsable",
                width: "15%",
              },
              

              {
                id: "edad",
                name: "Edad",
                width: "10%"
              },{
                id: "familia",
                name: "Familia",
                width: "10%"
              },{
                id: "trabajaActualmente",
                name: "Trabaja ?",
                width: "10%",
                 formatter: (cell) => `${ cell === null ? "": cell === "0" ? "No":"Si"}`
              },

              {
                name: "Actions",
                width: "10%",
                formatter: (cell, row) =>
                  _(
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      
                     
                      <button
                        type="button"
                        onClick={() => setShow({show_:true,id:row.cells[0].data})}
                        className="btn btn-primary"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-plus-circle-dotted"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                        </svg>
                      </button>
                      <button
                        type="button"
                        disabled={row.cells[7].data ===null ? true :false}
                        onClick={() => Deletelink(row.cells[0].data)}
                        className="btn btn-danger"
                      >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
</svg>
                      </button>
                      <a className={"btn btn-secondary"} target="_blank" rel="noopener noreferrer" href={`/api/reportes/perfil.php?id=${`${row.cells[0].data}`}`}>
                      <svg xmlns="http://www.w3.org/2000/svg" 
                    width="16" 
                    height="16" fill="currentColor" className="bi bi-filetype-pdf" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"/>
</svg>
                      </a>
                      <button
                        className={"btn btn-primary"}
                        title="ver votantes"
                        onClick={() =>
                          History(`/info/${`${row.cells[0].data}`}`)
                        }
                        
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-binoculars"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z" />
                        </svg>
                       
                      </button>
                    </div>
                  ),
              },
            ]}
            search={true}
            pagination={{
              enabled: true,
              limit: 7,
            }}
          />
        </>
      )}
    </div>
  );
};
export default Perfil;
